import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Success from "../views/Success.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/success",
    name: "success",
    component: Success,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/books",
    name: "books",
    component: () =>
      import(/* webpackChunkName: "books" */ "../views/BooksList.vue"),
  },
  {
    path: "/books/:bookId",
    name: "BookForm", 
    component: () =>
      import(/* webpackChunkName: "bookform" */ "../views/BookForm.vue"),
    props: true,
  },
  {
    path: "/checkout/:orderId",
    name: "Checkout",
    component: () =>
      import(/* webpackChunkName: "checkout" */ "../views/CheckoutPage.vue"),
    props: true,
  },
  {
    path: "/confirmation/:orderId",
    name: "confirmation",
    component: () =>
      import(
        /* webpackChunkName: "confirmation" */ "../views/ConfirmationPage.vue"
      ),
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/LoginView.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/RegisterView.vue"),
  },
  {
    path: "/blogs",
    name: "blog",
    component: () =>
      import(/* webpackChunkName: "blog" */ "../views/blogView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Info&Contact.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/PrivacyPolicy.vue"),
  },
  {
    path: "/terms&service",
    name: "terms&service",
    component: () =>
      import(
        /* webpackChunkName: "terms&service" */ "../views/Terms&Service.vue"
      ),
  },
  {
    path: "/reviews",
    name: "reviews",
    component: () =>
      import(/* webpackChunkName: "reviews" */ "../views/Reviews.vue"),
  },
  {
    path: "/razorpaysuccess",
    name: "RazorpaySuccessPage",
    component: () => import("@/views/RazorPaySuccess.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If user clicks back/forward, return to their previous position.
    if (savedPosition) {
      return savedPosition;
    }
    // Otherwise, scroll immediately to the top left of the page.
    return { top: 0, left: 0 };
  },
  // ⬆️ END ADDED ⬆️
});

export default router;
